<template>
	<div>
		<slot :setFilter="mSetFilter" :getFilter="mGetFilter"></slot>
	</div>
</template>

<script>
	export default {
        name: 'filterDefiner',
        inject: ['reportFilter', 'setFilter', 'getFilter'],
		props: {
            sort: {
                type: Number,
                default: undefined,
            }
        },
        beforeMount() {
            this.filterIndex = this.reportFilter(this.sort);
        },
		data() {
			return {
                /**上级组件分配的索引,过滤器修改时要回报此值 */
                filterIndex: undefined,
            };
		},
		methods: {
            /**对外接口,为同核心层提供的setFilter进行区别,增加了前缀 */
			mSetFilter(filter) {
                this.setFilter(this.filterIndex, filter);
            },
            /**对外接口,为同核心层提供的getFilter进行区别,增加了前缀 */
			mGetFilter() {
                return this.getFilter(this.filterIndex);
            },
		},
	};
</script>
